import { Connector } from "./Connector";
export async function loadExternalConnectInteraction(engine) {
    await engine.addInteractor("externalConnect", (container) => new Connector(container));
}
export * from "./Options/Classes/Connect";
export * from "./Options/Classes/ConnectLinks";
export * from "./Options/Interfaces/IConnect";
export * from "./Options/Interfaces/IConnectLinks";
